import { useEffect, useState } from 'react'
import 'intersection-observer'

/**
 * Hook for the IntersectionObserver API
 *
 * @param target A ref pointing to the target element to watch
 * @param root A ref pointing to the root element to watch
 * @param threshold Either a single number or an array of numbers between 0.0 and 1.0, specifying a ratio of intersection area to total bounding box area for the observed target
 */
export function useIntersectionObserver(
  target?: HTMLElement | null,
  root?: HTMLElement | null,
  threshold: number | number[] = 1
) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio < 1) {
          setIntersecting(true)
        } else {
          setIntersecting(false)
        }
      },
      {
        root,
        threshold,
      }
    )

    if (target) {
      observer.observe(target)
    }

    return () => {
      observer.disconnect()
    }
  }, [root, target, threshold])

  return isIntersecting
}
